import { render } from "./TeamHome.vue?vue&type=template&id=246a5714&scoped=true"
import script from "./TeamHome.vue?vue&type=script&lang=js"
export * from "./TeamHome.vue?vue&type=script&lang=js"

import "./TeamHome.vue?vue&type=style&index=0&id=246a5714&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-246a5714"]])

export default __exports__